// extracted by mini-css-extract-plugin
module.exports = {"root":"IconPrivate_root__3CHh4"};